"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCssText = exports.generateUniqueId = exports.decodeB64 = exports.base64Decode = exports.isFunction = exports.getObjectByName = exports.getTopAccessibleWindow = exports.isWindowAccessible = void 0;
function isWindowAccessible(windowObject) {
    try {
        if (windowObject.document) {
            return true;
        }
    }
    catch (ignored) { }
    return false;
}
exports.isWindowAccessible = isWindowAccessible;
function getTopAccessibleWindow() {
    const getTopAccessibleWindow_ = (windowObject, accessibleWindow) => {
        if (isWindowAccessible(windowObject)) {
            if (windowObject !== window.top) {
                return getTopAccessibleWindow_(windowObject.parent, windowObject);
            }
            else {
                return windowObject;
            }
        }
        else {
            return accessibleWindow;
        }
    };
    if (typeof window !== 'undefined') {
        return getTopAccessibleWindow_(window);
    }
    else {
        return undefined;
    }
}
exports.getTopAccessibleWindow = getTopAccessibleWindow;
function getObjectByName(name, obj) {
    let curr = obj;
    const parts = name.split('.');
    while (parts.length > 0) {
        const part = parts.shift();
        if (part != null && curr[part] != null) {
            curr = curr[part];
        }
        else {
            return undefined;
        }
    }
    return curr;
}
exports.getObjectByName = getObjectByName;
function isFunction(value) {
    if (typeof value === 'function' && typeof value.call !== 'undefined') {
        return true;
    }
    else if (value) {
        const className = Object.prototype.toString.call(value);
        if (className === '[object Function]' ||
            (typeof value.call !== 'undefined' &&
                typeof value.propertyIsEnumerable !== 'undefined' &&
                !value.propertyIsEnumerable('call'))) {
            return true;
        }
    }
    return false;
}
exports.isFunction = isFunction;
function base64Decode(data) {
    if (typeof window !== 'undefined' && typeof window.atob === 'function') {
        return window.atob(data);
    }
    else {
        return new Buffer(data).toString('base64');
    }
}
exports.base64Decode = base64Decode;
function decodeB64(b64) {
    try {
        return JSON.parse(base64Decode(decodeURIComponent(b64)));
    }
    catch (ignored) { }
    return null;
}
exports.decodeB64 = decodeB64;
function generateRandomValues() {
    if (typeof window !== 'undefined' &&
        typeof window.crypto !== 'undefined' &&
        typeof window.crypto.getRandomValues !== 'undefined') {
        const randomValues = new Uint16Array(5);
        window.crypto.getRandomValues(randomValues);
        return Array.from(randomValues);
    }
    else {
        const nextRandomNumber = () => {
            return Math.floor(Math.random() * 0xffff + 1);
        };
        return [nextRandomNumber(), nextRandomNumber(), nextRandomNumber(), nextRandomNumber(), nextRandomNumber()];
    }
}
function generateRandomString() {
    return generateRandomValues().reduce((acc, value) => acc + value.toString(16), '');
}
function generateUniqueId() {
    const timestamp = new Date().getTime();
    return generateRandomString() + '_' + timestamp;
}
exports.generateUniqueId = generateUniqueId;
function addCssText(cssText, opt_container) {
    const cssNode = document.createElement('style');
    cssNode.type = 'text/css';
    const head = opt_container || document.getElementsByTagName('HEAD')[0];
    head.appendChild(cssNode);
    const cssTextNode = document.createTextNode(cssText);
    cssNode.appendChild(cssTextNode);
    return cssNode;
}
exports.addCssText = addCssText;
//# sourceMappingURL=utils.js.map